module.exports = function getResource(label, vars = []) {
    let resources = {
        addTheseTitle: 'Ajoutez-les pour moins de 15 $'
    };

    return resources[label];
};
